//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import DataEstrategyService from '@/apps/data-platform/services/data_estrategy/reports';
import domainService from '@/apps/data-platform/services/master_data/domain_service';
import tasks from '@/js/tasks';
export default {
  name: 'AdminAssessmentReport',
  data: function data() {
    return {
      item: null,
      valid: true,
      report: {},
      readonly: false,
      organizations: [],
      update_hours: null
    };
  },
  methods: {
    getOrganizations: function getOrganizations() {
      var _this = this;
      domainService.getOrganizationsDetail().then(function (response) {
        if (response.success && response.code === 200) {
          response.data.forEach(function (x) {
            _this.organizations.unshift({
              name: x.alias,
              id: x.code
            });
          });
        }
      });
    },
    getInfo: function getInfo() {
      var _this2 = this;
      DataEstrategyService.get_assessment_report().then(function (response) {
        _this2.report = response.data;
      });
    },
    updateInfo: function updateInfo() {
      if (!this.$refs.form.validate()) {
        return;
      }
      var data = {
        'data_update': this.report
      };
      DataEstrategyService.update_assessment_report(data).then(function (response) {
        if (response.success && response.code === 200) {
          tasks.toast.success('Change updated!');
        }
      });
    }
  },
  beforeMount: function beforeMount() {
    this.getOrganizations();
    this.getInfo();
  },
  computed: {
    rules: function rules() {
      var _this3 = this;
      return {
        general: [function (v) {
          return !!v || _this3.translate('reglas.field');
        }],
        update_hours: [function (v) {
          return !!v.length || _this3.translate('reglas.field');
        }, function (v) {
          return v.length >= 2 || _this3.translate('reglas.insights_min_2_update_hours');
        }]
      };
    },
    getClassTable: function getClassTable() {
      return 'col-sm-12';
    }
  }
};